export default {
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    type: {
        type: String,
        default: undefined
    }, 
    theme: {
        type: String,
        default: undefined
    }, 
    valueField: {
        type: String,
        default: undefined
    }, 
    colorField: {
        type: String,
        default: undefined
    }, 
    textField: {
        type: String,
        default: undefined
    }, 
    template: {
        type: [String, Function],
        default: undefined
    }, 
    colors: {
        type: Array,
        default: undefined
    }, 

    // Events
    itemCreated: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treemap-vue-wrapper/src/KendoTreeMap/TreeMapProps.js